import React from 'react';
import emptyCart from '../../images/empty-cart.svg';
import { Box, Container } from '@mui/material';
import { PrimaryButton } from '../Button';

const EmptyCart = () => {
  return (
    <Container sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', flexGrow: 1, alignItems: 'center' }} data-testid="empty-cart" disableGutters>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: {md: '60%', xs: '100%'}, height: {lg: '60%', xs: '100%'}}}>
          <img alt='empty-cart' src={emptyCart} data-testid="empty-cart-image" style={{ width: '100%', height: 'auto' }} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <a href='/products'>
          <PrimaryButton>Go to products</PrimaryButton>
        </a>
      </Box>
    </Container>
  );
};

export default EmptyCart;